import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import api from '../../api';


export const DownloadResults = ( { token, jobs } ) => {
  const downloadAll = async (e) => {
    e.preventDefault();
    const toastId = toast.loading("Gathering data..");
    console.info("Downloading jobs")
    const svgs = Array.from(document.getElementsByClassName("svg-content"));
    console.debug("SVG images:", svgs);

    const response = await api.post(
      '/result/download-all', {
        "job_ids": jobs.map(j => j.id),
        "svg_data": Object.fromEntries(
          svgs.map(svgElement => [svgElement.parentElement.id, new XMLSerializer().serializeToString(svgElement)])
        ),
      },
      {
        responseType: 'blob',
        headers: {
          authorization: token
        }
      }
    ).then(
      response => {toast.loading("Zipping data..", {id: toastId}); return response}
    ).catch(error => {
      console.error(error);
      const message = error.response.data.detail;
      toast.error(message, {id: toastId})
      });
    console.debug("Obtained zip response:", response);
    const [rawFileName, ...rest] = await api.get(
      '/info/dataset', {
        headers: {
          authorization: token
        },
      },
    ).then(
        info => info.data.file.split('/').reverse()
      ).catch(error => {
        console.error(error);
        const message = error.response.data.detail;
        toast.error(message, {id: toastId})
        }
      );
    const [stem, ] = rawFileName.split('.');
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const a = document.createElement("a");
    a.href = url;
    a.download = `${stem}-Fatty-Acylizer.zip`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    toast.success("Starting download", {id: toastId});
  };

  return (
    <button className="btn btn-secondary" href="#" onClick={downloadAll} disabled={jobs === []} type="button">
      Download results
    </button>
  )
};
